module.exports = __webpack_public_path__ + "img/新生涯网站首页_34.089cf392.jpg";